import { Link, useNavigate } from "@remix-run/react";
import { Card, CardBody, CardFooter, Image } from "@heroui/react";
import { MdChevronRight } from "react-icons/md";
import { BlogCardProps } from "app/routes/Blogs._index/interface";

export const BlogCard = ({ imageSrc, title, category, summary, slug }: BlogCardProps) => {
  const navigate = useNavigate();

  return (
    <Card className=" shadow-none w-full">
      <CardBody className="overflow-visible p-0 relative">
        <Link to={`/blogs/${category?.title ?? "_"}/${slug}`} prefetch="intent">
          <Image
            shadow="none"
            radius="none"
            width="100%"
            height={200}
            alt={`Image related to ${title}`}
            className="h-[13rem] max-h-[13rem] object-fill lg:h-[11.5rem]"
            src={
              imageSrc ??
              "https://dfstudio-d420.kxcdn.com/wordpress/wp-content/uploads/2019/06/digital_camera_photo-1080x675.jpg"
            }
            loading="lazy"
          />
        </Link>
        {category && category?.title && (
          <div className="absolute left-0 top-0 w-full h-fit z-10">
            <div className="flex p-4">
              <div className="cursor-pointer" onClick={() => navigate(`/blogs/${category.title}`)}>
                <div className="bg-yellow text-white px-2 py-1 rounded text-sm uppercase">
                  {category.title}
                </div>
              </div>
            </div>
          </div>
        )}
      </CardBody>
      <CardFooter className="bg-white-bg dark:bg-zinc-700 flex items-start flex-col gap-4 justify-between px-4">
        <Link to={`/blogs/${category?.title ?? "_"}/${slug}`} prefetch="intent">
          <h4 className="font-semibold text-base flex justify-start items-start text-left w-full capitalize">
            {title}
          </h4>
          <div className="w-full text-start mt-2">
            <p className="text-default-500 line-clamp-3 text-sm first-letter:capitalize">
              {summary}
            </p>
          </div>
        </Link>
        <Link to={`/blogs/${category?.title ?? "_"}/${slug}`} prefetch="intent">
          <div className="flex gap-x-2 items-center text-sm hover:border cursor-pointer border-gray-500 dark:border-gray-400 px-4 py-1 rounded-lg">
            See more <MdChevronRight />{" "}
          </div>
        </Link>
      </CardFooter>
    </Card>
  );
};
